<mat-sidenav-container class="{{getContainerIndex()}}" fullscreen>

  <mat-sidenav-content class="{{classDiv}}" fxLayout="column">

    <mat-toolbar class="custom-nav-bar-default {{getCustomNavBar()}}" *ngIf="!isPagInicial">

      <div class="form-row">

        <div class="col-lg-8 col-md-8 col-sm-8 col-8" style="align-self: center;">
          <custom-nav-bar *ngIf="showMenu"></custom-nav-bar>
          <a href="#/paginaInicial">
            <img src="{{getHeaderPath()}}" alt="image" style="height: 60px; margin-top: 5px; margin-bottom: 5px;">
          </a>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4 col-p-4 col-p-12" style="align-self: center;">
          <div class="versao-default versao">Versão: {{getSystemVersion()}}</div>
          <div class="usuario-logado-default usuario-logado">{{usuarioLogado}}</div>
        </div>
      </div>
    </mat-toolbar>

    <mat-toolbar class="custom-nav-bar-default custom-nav-bar-pg-inicial" *ngIf="isPagInicial">

      <div class="form-row">

        <div class="col-lg-8 col-md-8 col-sm-8 col-8" style="align-self: center;">
          <custom-nav-bar *ngIf="showMenu"></custom-nav-bar>
          <a href="#/paginaInicial">
            <img src="{{getHeaderPath()}}" alt="image" style="height: 60px; margin-top: 5px; margin-bottom: 5px;">
          </a>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4 col-p-4 col-p-12" style="align-self: center;">
          <div class="versao-default versao-pg-inicial">Versão: {{getSystemVersion()}}</div>
          <div class="usuario-logado-default usuario-logado-pg-inicial">{{usuarioLogado}}</div>
        </div>
      </div>
    </mat-toolbar>
    
    <router-outlet></router-outlet>
  
  </mat-sidenav-content>

</mat-sidenav-container>